/** 设置默认sort */
export const setDefaultSort = list => {
  let sort = null;
  list.some(item => {
    if (item.default) {
      sort = item.sort_id;
      return true;
    }
  });
  if(sort === null && list.length){
    sort = list[0].sort_id;
  } 
  return sort;
};
/** 获取个人素材列表 */
export const getSortList = () => {
  let params = {
    pages: 1,
    count: 100
  };
  // eslint-disable-next-line no-undef
  return lib.tmsapi.get({
    api: 'api/test/sort/list',
    data: params,
  }).then(res=>{
    if (res && res.data) {
      return res.data || [];
    }
    return [];
  });
};
/** 公共素材分类 */
export const getCommonList = (parent_id) => {
  // eslint-disable-next-line no-undef
  return lib.tmsapi.get({
    api: 'api/test/material_category/list',
    data: {
      parent_id
    }
  }).then(res=>{
    const list = res.data ||[];
    commonFormatData(list);
    return list;
  });
};
/** 公共素材tab字段修改成与个人一致 */
export const commonFormatData = (list) => {
  list.forEach(item=>{
    item.sort_id = item.id;
    item.sort_name = item.category_name;
  });
};